import { atom } from "jotai";
import type { Nullable } from "vitest";

import type { WebsocketService } from "./websocket.service";

export const socketAtom = atom<Nullable<WebsocketService>>(null);
